module.exports = __webpack_public_path__ + "media/images/icon_themelist-4f9d3f87fc9528da74b2edbc3d0ce82d.svg";